import './App.css';
import data from './data/data.json';
import React from 'react';
import ShipGenerator from './components/ShipGenerator';

function App() {
  return (
    <div className="App">
      <ShipGenerator data={data}/>
    </div>
  );
}

export default App;